<template>
  <div>
    <label class="font-weight-bold">Neues Bild auswählen</label>
    <div class="form-group">
      <table class="mb-3 text-muted">
        <tbody>
          <tr>
            <td>Maximale Abmessung:</td>
            <td>400x400px</td>
          </tr>
          <tr>
            <td>Maximale Dateigröße:</td>
            <td>1mb</td>
          </tr>
          <tr>
            <td>Erlaubte Dateiformate:</td>
            <td>jpg, png</td>
          </tr>
        </tbody>
      </table>
      <b-form-file v-on:input="speichern" accept=".jpg, .png" lang="de" placeholder="Datei auswählen oder hierher ziehen und ablegen..." drop-placeholder="Datei hier ablegen..."></b-form-file>
    </div>
    <div v-if="isLoading === false">
      <div v-if="bild !== ''">
        <label class="font-weight-bold">Neues Bild</label><br>
        <img :src="bild" class="img-fluid" id="bild">
      </div>
    </div>
    <SpinnerComponent v-else />
</div>
</template>

<script>
import {storage} from "../plugins/firebase"
import { uploadBytesResumable, ref as storageRef, getDownloadURL } from "firebase/storage"


import SpinnerComponent from './SpinnerComponent'
export default {
  name: 'UploadImageComponent',
  components: {
    SpinnerComponent
  },
  props: {
    configurationId: String
  },
  methods: {
    speichern: function(datei) {
      this.isLoading = true
      this.bildHochladen(datei)
      .then(() => {
        this.getBildUrl()
        .then(url => {
          this.bild = url
          this.$emit('imageUpload', url)
        })
      })
      .then(() => this.isLoading = false)
      .catch(error => console.error(error)) // eslint-disable-line no-console
    },
    bildHochladen: function(datei) {
      return new Promise((resolve, reject) => {
        const config = {
          contentType: 'image/jpeg'
        }

        const uploadTask = uploadBytesResumable(storageRef(storage,`configurationImages/${this.configurationId}.jpg`), datei, config)

        uploadTask.on('state_changed',
          (() => {}),
          (error => reject(error)),
          (()=>{resolve()})
        )

      })
    },
    getBildUrl: function() {
      return getDownloadURL(storageRef(storage, `configurationImages/${this.configurationId}.jpg`) )
    }
  },
  data() {
    return {
      isLoading: false,
      bild: ''
    }
  }
}
</script>

<style scoped>
.custom-file-label::after {
  content: 'Durchsuchen';
}
</style>